import React, { Suspense } from "react";
import { render } from "react-dom";
import { Spin } from "antd";
import {
  BrowserRouter,
  Routes,
  Route,
  // eslint-disable-next-line
  Link,
} from "react-router-dom";

import Home from "./Pages/Home";
import "./index.css";

const FormSucess = React.lazy(() => import("./components/FormSuccess"));

const rootElement = document.getElementById("root");
render(
  <Suspense
    fallback={
      <div className="text-center">
        <Spin />
      </div>
    }
  >
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/success" element={<FormSucess />} />
      </Routes>
    </BrowserRouter>
  </Suspense>,

  rootElement
);
